import { SVGIcon } from './SVGIcon';

export function CoffeeOutlined() {
	return (
		<SVGIcon width="120" height="120" viewBox="2 0 42 42" size={{ x1: '1', y1: '0.47', x2: '0', y2: '0.475' }}>
			<defs>
				<style>{`.coffee-stroke { fill: none; stroke: url(#linear-gradient); stroke-linecap: round; stroke-linejoin: round; stroke-width: 2px }`}</style>
			</defs>
			<g id="coffee-outlined" transform="translate(-0.987)">
				<path
					id="coffee-path"
					className="coffee-stroke"
					d="M10 14h26v14.52A7.48 7.48 0 0 1 28.52 36h-11A7.48 7.48 0 0 1 10 28.52V14h0zM4 36h38v0a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4v0h0zM36 16h3.71A4.29 4.29 0 0 1 44 20.29v3.43A4.29 4.29 0 0 1 39.71 28H36h0V16h0zM27 4a3.7 3.7 0 0 1 2 3c0 2-2 1.76-2 4M19 4a3.7 3.7 0 0 1 2 3c0 2-2 1.76-2 4"
					transform="translate(0 0)"
				/>
			</g>
		</SVGIcon>
	);
}
